module.exports = "https://99designs-start-assets.imgix.net/js/525a59ebceacf930b174a3b8d53db8a0.png";